import React from 'react';
import { ToastContainer as Base } from 'react-toastify';
var ToastContainer = function ToastContainer() {
  return React.createElement(Base, {
    position: 'bottom-center',
    autoClose: 2500,
    hideProgressBar: false,
    newestOnTop: true,
    closeOnClick: true,
    rtl: false,
    pauseOnFocusLoss: true,
    draggable: true,
    pauseOnHover: true
  });
};
export default ToastContainer;